// extracted by mini-css-extract-plugin
export default {"nodeWrapper":"NodeWrapper_nodeWrapper__f2-Uj","nodeHeader":"NodeWrapper_nodeHeader__aRvd0"};